import { render, staticRenderFns } from "./MenuActions.vue?vue&type=template&id=7094ce5e&scoped=true"
import script from "./MenuActions.vue?vue&type=script&lang=js"
export * from "./MenuActions.vue?vue&type=script&lang=js"
import style0 from "./MenuActions.vue?vue&type=style&index=0&id=7094ce5e&prod&scoped=true&lang=css"
import style1 from "./MenuActions.vue?vue&type=style&index=1&id=7094ce5e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7094ce5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VIcon,VRow})
